import { useRef, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const MainPlayer = ({ video, isVideoSelected, onPlayClick }) => {
  const [showHint, setShowHint] = useState(false);
  if (!video?.url) {
    return (
      <Box sx={{ position: "relative", height: 320 }}>
        <img
          src={video?.thumbnail}
          alt="video thumbnail"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: 0,
            filter: "brightness(0.5)",
          }}
        />

        {/* <IconButton
          onClick={() => {
            setShowHint(false);
            onPlayClick?.();
          }}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "rgba(0,0,0,0.6)",
            color: "#fff",
            "&:hover": {
              backgroundColor: "rgba(0,0,0,0.8)",
            },
          }}
        >
          <PlayArrowIcon sx={{ fontSize: 48 }} />
        </IconButton> */}

        <Box
          onClick={() => {
            // setShowHint(false);
            if (!isVideoSelected) setShowHint(true);
            onPlayClick?.();
          }}
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <Box
            sx={{
              width: 62,
              height: 62,
              backgroundColor: "#A100FF",
              // borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PlayArrowIcon sx={{ color: "#fff", fontSize: 32 }} />
          </Box>
        </Box>

        {showHint && !isVideoSelected && (
          <Typography
            sx={{
              position: "absolute",
              bottom: 16,
              width: "100%",
              textAlign: "center",
              color: "#fff",
              fontWeight: 600,
              background: "rgba(0,0,0,0.5)",
              padding: "6px 0",
            }}
          >
            Select an episode to play
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" mb={1} sx={{ color: "#fff" }}>
        {video.title}
      </Typography>
      <Box sx={{ width: "100%", height: 320, position: "relative" }}>
        <video
          src={video.url}
          poster={video?.thumbnail}
          controls
          // autoPlay
          crossOrigin="anonymous"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: 0,
          }}
        />
      </Box>
    </Box>
  );
};

export default MainPlayer;
